(function () {

  if (window.__marstelaMoschettoneSimpleSwap) return;
  window.__marstelaMoschettoneSimpleSwap = true;

  document.addEventListener('change', function (event) {

    const input = event.target;

    if (!(input instanceof HTMLInputElement)) return;

    const picker = input.closest(
      'swatches-variant-picker-component[data-product-handle="moschettone-aggiuntivo"]'
    );

    if (!picker) return;

    /*
     * Blocchiamo SOLO per questo prodotto
     * il cambio variante standard della card Shopify.
     */
    event.stopImmediatePropagation();
    event.stopPropagation();

    const card = picker.closest('product-card');

    if (!card) return;

    const imageUrl =
      input.dataset.variantImageUrl;

    const variantId =
      input.dataset.firstAvailableOrFirstVariantId ||
      input.dataset.variantId;

    if (!imageUrl || !variantId) return;


    /* ================================
       CAMBIO IMMAGINE
       ================================ */

    const image = card.querySelector(
      '.card-gallery .product-media__image'
    );

    if (image) {
      image.removeAttribute('srcset');
      image.src = imageUrl;
    }


    /* ================================
       QUICK ADD
       ================================ */

    const quickAdd =
      card.querySelector('quick-add-component');

    if (quickAdd) {

      quickAdd.dataset.quickAddButton = 'add';

      const variantInput =
        quickAdd.querySelector(
          'input[name="id"]'
        );

      if (variantInput) {
        variantInput.value = variantId;
        variantInput.disabled = false;
      }

      /* MARSTÈLA - immagine corretta per animazione fly-to-cart */
      const addToCart =
        quickAdd.querySelector(
          'add-to-cart-component'
        );

      if (addToCart) {
        addToCart.setAttribute(
          'data-product-variant-media',
          imageUrl
        );
      }
    }


    /* ================================
       LINK SCHEDA PRODOTTO
       ================================ */

    card.querySelectorAll(
      '[ref="productCardLink"], [ref="cardGalleryLink"], [ref="productTitleLink"]'
    ).forEach(function (link) {

      if (!link.href) return;

      const url = new URL(link.href);

      url.searchParams.set(
        'variant',
        variantId
      );

      link.href = url.toString();

    });


    /* ================================
       WISHLIST MARSTÈLA
       ================================ */

    card.setAttribute(
      'data-marstela-selected-variant-id',
      variantId
    );

  }, true);

})();